<ef-process-detail [process]="process$ | async"></ef-process-detail>
<ef-loading-container [observables]="[expenses$, directReports$, perDiemTypes$, travelTypes$, expenseSummary$, userInfo$]"></ef-loading-container>

<ng-container *ngIf="entryDateInputs$ | async as entryDates">
<ef-expense-list
    #expenseList
    [expenses]="expenses$ | async"
    [showReimbursedAmount]="showReimbursedAmount$ | async"
    [failureMessage]="failureMessages$ | async"
    [successMessage]="entrySaveMessage"
    [userWebColors]="userWebColors$ | async"
    [expenseLines]="expenseLines$ | async"
    [expenseReceipts]="expenseReceipts$ | async"
    [directReports]="directReports$ | async"
    [perDiemTypes]="perDiemTypes$ | async"
    [travelTypes]="travelTypes$ | async"
    [selectedExpense]="expenseSummary$ | async"
    [selectedDetail]="selectedDetailSubject | async"
    [selectedUser]="selectedUser$ | async"
    [userInfo]="userInfo$ | async"
    [superUserEnabled]="superUser"
    [tasks]="tasks$ | async"
    [expenseItems]="expenseItems$ | async"
    [startDate]="(dateFilter$ | async)?.startDate"
    [endDate]="(dateFilter$ | async)?.endDate"
    [entryStartDate]="entryDates.entryStartDate"
    [entryEndDate]="entryDates.entryEndDate"
    [roleId]="getProcessRole(process?.ProcessID, userInfo$ | async)"
    [process]="process"
    [approving]="approving"
    [validating]="validating"
    (addExpense)="onAddExpense($event)"
    (addExpenseLine)="onAddExpenseLine($event)"
    (editExpense)="onEditExpense($event)"
    (ShowExpenseDetail)="onShowExpenseDetail($event)"
    (deleteExpense)="onDeleteExpense($event)"
    (oversignExpense)="onOversignExpense($event)"
    (ConvertExpense)="onConvertExpense($event)"
    (ValidateExpense)="onValidateExpense($event)"
    (ApproveExpense)="onApproveExpense($event)"
    (UnvalidateExpense)="onUnvalidateExpense($event)"
    (UnapproveExpense)="onUnapproveExpense($event)"
    (DisapproveExpense)="onDisapproveExpense($event)"
    (editDetail)="onEditDetail($event)"
    (selectDetail)="onSelectDetail($event)"
    (deleteDetail)="onDeleteDetail($event)"
    (editReceipt)="onEditReceipt($event)"
    (selectReceipt)="onSelectReceipt($event)"
    (deleteReceipt)="onDeleteReceipt($event)"
    (dateFiltersChanged)="onDateFiltersChanged($event)"
    (taskFilterChanged)="onTaskFilterChanged($event)"
    (expenseItemFilterChanged)="onExpenseItemFilterChanged($event)"
    (userSelected)="onUserSelected($event)"
    (CanClose)="onCanClose($event)"
    (AddSelectedExpense)="onAddSelectedExpense($event)"
    (RemoveSelectedExpense)="onRemoveSelectedExpense($event)"
    (ClearSelectedExpenses)="onClearSelectedExpenses($event)"
    (ShowPdbo)="onShowPdbo($event)"
></ef-expense-list>
</ng-container>
